<ion-header [translucent]="true">
  <ion-toolbar>
    <ion-buttons slot="end">
      <ion-button (click)="cancel()">
        <ion-icon size="large" name="close-outline"></ion-icon>
      </ion-button>
    </ion-buttons>
    <ion-title>
      {{ machine?.inventoryNumber }} {{ machine?.manufacturer }}
      {{ machine?.type }}</ion-title
    >
  </ion-toolbar>
</ion-header>
<ion-content [fullscreen]="true">
  <div class="container">
    @if (machine) {
    <div>
      <lib-image-preview
        [fileOrBlob]="profilePicture"
        style="height: 300px"
        (click)="openProfilePicture()"
      ></lib-image-preview>
      <div class="stretch first-one">
        <div>Inventarnummer:</div>
        <div>{{ machine.inventoryNumber }}</div>
      </div>
      <div class="stretch">
        <div>Hersteller:</div>
        <div>{{ machine.manufacturer }}</div>
      </div>
      <div class="stretch">
        <div>Typ:</div>
        <div>{{ machine.type }}</div>
      </div>
      <div class="stretch">
        <div>Geräteart:</div>
        <div>{{ machine.category }}</div>
      </div>
      <div class="stretch">
        <div>Baujahr:</div>
        <div>{{ machine.constructionYear }}</div>
      </div>
      <div class="stretch">
        <div>Serien-/Fabriknummer:</div>
        <div>{{ machine.serialNumber }}</div>
      </div>
      <div class="stretch">
        <div>Betriebsstunden:</div>
        <div>{{ machine.operatingHours }}</div>
      </div>
      @if(!machine.inspectionFree){
      <div class="stretch">
        <div>Letzte DGUV-Prüfung:</div>
        <div>{{ tools.formatDt(machine.lastInspectionUtc) }}</div>
      </div>
      }@else{
      <div class="stretch">
        <div>Nächste Prüfung:</div>
        <div>{{ tools.formatDt(machine.nextManualInspection) }}</div>
      </div>
      }
      <div class="stretch">
        <div>Status:</div>
        @if(machine.inspectionNecessary){
        <div class="centered">
          <ion-icon
            style="margin-right: 3px"
            class="red"
            size="small"
            name="close-circle-outline"
          ></ion-icon>
          Prüfung notwendig
        </div>
        } @if(!machine.inspectionNecessary && (machine.nextManualInspection !=
        null || !machine.inspectionFree)){
        <div class="centered">
          <ion-icon
            style="margin-right: 3px"
            size="small"
            class="green"
            name="checkmark-circle-outline"
          ></ion-icon>
          Geprüft
        </div>
        }
      </div>
      @if(machine.notes){
      <div class="stretch">
        <div>Bemerkungen:</div>
        <div>{{ machine.notes }}</div>
      </div>
      }
      <div class="stretch last-one">Dokumente:</div>
      @for(doc of machineDocuments; track doc.id){
      <div class="base-padding">
        <ion-button
          fill="outline"
          (click)="openFile(doc.id)"
          style="width: 100%"
        >
          <ion-icon slot="start" [name]="state.getIcon(doc)"></ion-icon>
          {{ doc.displayName }}
        </ion-button>
      </div>
      }
    </div>
    }
    <div class="stretch">
      @if(state.userHasMinType(1)){
      <ion-button style="width: 100%" (click)="edit()">Bearbeiten</ion-button
      ><ion-button style="width: 100%" color="danger" (click)="delete()"
        >Löschen</ion-button
      >
      }
    </div>
  </div>
</ion-content>
